"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var icons_1 = require("@ant-design/icons");
var messageContext_1 = require("../../hoc/messageContext");
var typography_1 = __importDefault(require("antd/es/typography"));
var button_1 = __importDefault(require("antd/es/button"));
var select_1 = __importDefault(require("antd/es/select"));
var switch_1 = __importDefault(require("antd/es/switch"));
var table_1 = __importDefault(require("antd/es/table"));
var space_1 = __importDefault(require("antd/es/space"));
var popconfirm_1 = __importDefault(require("antd/es/popconfirm"));
var Title = typography_1.default.Title;
var ListCatalogs = function () {
    var _a = (0, react_1.useState)([]), catalogs = _a[0], setCatalogs = _a[1];
    var _b = (0, react_1.useState)([]), brands = _b[0], setBrands = _b[1];
    var _c = (0, react_1.useState)(undefined), selectedBrand = _c[0], setSelectedBrand = _c[1];
    var _d = (0, react_1.useState)(true), loading = _d[0], setLoading = _d[1];
    var _e = (0, react_1.useState)(''), error = _e[0], setError = _e[1];
    var _f = (0, messageContext_1.useMessageContext)(), showSuccess = _f.showSuccess, showError = _f.showError;
    (0, react_1.useEffect)(function () {
        var fetchCatalogs = function () { return __awaiter(void 0, void 0, void 0, function () {
            var isAdmin, response, data, uniqueBrands, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        isAdmin = true;
                        return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/car_catalogs?admin=").concat(isAdmin))];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _a.sent();
                        uniqueBrands = Array.from(new Set(data.map(function (car) { return car.brand; })));
                        setBrands(uniqueBrands);
                        setCatalogs(data);
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        setError('Error fetching catalogs');
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchCatalogs();
    }, []);
    if (loading)
        return react_1.default.createElement("div", { style: { marginTop: '50px', textAlign: 'center' } }, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...");
    if (error)
        return react_1.default.createElement("div", { style: { marginTop: '50px', textAlign: 'center' } }, error);
    var onFilterChange = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var capitaliseValue, response, data, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSelectedBrand(value);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    capitaliseValue = value.charAt(0).toUpperCase() + value.slice(1);
                    return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/car_catalogs/cars_by_brand?brand_name=").concat(capitaliseValue))];
                case 2:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _a.sent();
                    setCatalogs(data);
                    return [3 /*break*/, 6];
                case 4:
                    e_2 = _a.sent();
                    setError('Error fetching catalogs');
                    return [3 /*break*/, 6];
                case 5:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function (carId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, fetchUpdatedCatalog, data, uniqueBrands, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/car_catalogs/").concat(carId), {
                            method: 'DELETE',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 8];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 5, 6, 7]);
                    return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/car_catalogs"))];
                case 3:
                    fetchUpdatedCatalog = _a.sent();
                    if (!fetchUpdatedCatalog.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return [4 /*yield*/, fetchUpdatedCatalog.json()];
                case 4:
                    data = _a.sent();
                    uniqueBrands = Array.from(new Set(data.map(function (car) { return car.brand; })));
                    setBrands(uniqueBrands);
                    setCatalogs(data);
                    return [3 /*break*/, 7];
                case 5:
                    e_3 = _a.sent();
                    setError('Error fetching catalogs');
                    return [3 /*break*/, 7];
                case 6:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 7:
                    showSuccess('Модель авто успешно удалена');
                    return [3 /*break*/, 9];
                case 8:
                    setLoading(false);
                    showError('Ошибка при удалении модели авто');
                    _a.label = 9;
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var toggleVisibility = function (carId, newVisibility) { return __awaiter(void 0, void 0, void 0, function () {
        var response, e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/car_catalogs/").concat(carId), {
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({ visibility: newVisibility }),
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error('Ошибка обновления');
                    }
                    setCatalogs(function (prev) { return prev.map(function (car) { return (car.id === carId ? __assign(__assign({}, car), { visibility: newVisibility }) : car); }); });
                    showSuccess("\u0412\u0438\u0434\u0438\u043C\u043E\u0441\u0442\u044C \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0430: ".concat(newVisibility ? 'Да' : 'Нет'));
                    return [3 /*break*/, 3];
                case 2:
                    e_4 = _a.sent();
                    showError('Ошибка при изменении видимости');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            sorter: function (a, b) { return a.id - b.id; },
        },
        {
            title: 'Бренд',
            dataIndex: ['brand'],
            key: 'brand',
            sorter: function (a, b) { return a.brand.localeCompare(b.brand); },
        },
        {
            title: 'Модель',
            dataIndex: ['model'],
            key: 'model',
            sorter: function (a, b) { return a.model.localeCompare(b.model); },
        },
        {
            title: 'Мощность',
            dataIndex: ['power'],
            key: 'power',
        },
        {
            title: 'Максимальная скорость',
            dataIndex: 'max_speed',
            key: 'max_speed',
            sorter: function (a, b) { return a.max_speed - b.max_speed; },
        },
        {
            title: 'Видимость',
            dataIndex: 'visibility',
            key: 'visibility',
            render: function (_, record) { return (react_1.default.createElement(switch_1.default, { checked: record.visibility, onChange: function (checked) { return toggleVisibility(record.id, checked); } })); },
        },
        {
            title: 'Действия',
            key: 'action',
            render: function (_, record) { return (react_1.default.createElement(space_1.default, { size: "middle" },
                react_1.default.createElement(react_router_dom_1.Link, { to: "/admin/catalog/".concat(record.id), state: { car: record } }, "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C"),
                react_1.default.createElement(popconfirm_1.default, { title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043C\u043E\u0434\u0435\u043B\u044C \u0430\u0432\u0442\u043E?", description: "\u0412\u044B \u0442\u043E\u0447\u043D\u043E \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u043C\u043E\u0434\u0435\u043B\u044C?", onConfirm: function () { return handleDelete(record.id); }, okText: "\u0414\u0430", cancelText: "\u041D\u0435\u0442" },
                    react_1.default.createElement(button_1.default, { type: "link", danger: true, icon: react_1.default.createElement(icons_1.DeleteOutlined, null), loading: loading }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C")))); },
        },
    ];
    return (react_1.default.createElement("div", { style: { padding: '20px' } },
        react_1.default.createElement(Title, { level: 1 }, "\u041A\u0430\u0442\u0430\u043B\u043E\u0433 \u043C\u0430\u0448\u0438\u043D"),
        react_1.default.createElement(select_1.default, { style: { width: 200, marginBottom: '20px' }, placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0431\u0440\u0435\u043D\u0434", value: selectedBrand, onChange: function (value) { return onFilterChange(value); }, options: brands.map(function (brand) { return ({
                label: brand,
                value: brand,
            }); }) }),
        react_1.default.createElement(table_1.default, { columns: columns, dataSource: catalogs, loading: loading, rowKey: "id", pagination: {
                total: catalogs.length,
                pageSize: 18,
                showSizeChanger: false,
            } })));
};
exports.default = ListCatalogs;
